/* eslint-disable no-nested-ternary */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { Switch, Tooltip } from '../../../canvasComponents/index';
import { FormattedMessage, IntlProvider, injectIntl } from 'react-intl';
import CustomToggleSettingsForm from './CustomToggle.settingsForm';
import getLocalParams from '../localizationCustoms';

const CustomToggle = class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      options: [],
    };
    this.setValue = this.setValue.bind(this);
  }

  componentDidMount() {
    const optionsData = [];

    const { state: { value }, props: { component: { trueValue, option1, option2, defaultValue } } } = this;

    if (option1 && option2 && trueValue) {
      const option1Value = trueValue === 'option1';
      const option2Value = trueValue === 'option2';

      optionsData.push({
        id: option1Value.toString(),
        value: option1Value,
        label: option1,
      });
      optionsData.push({
        id: option2Value.toString(),
        value: option2Value,
        label: option2,
      });
    }

    if ((value === null || typeof value === 'undefined') && defaultValue !== null) {
      this.setValue(defaultValue, optionsData);
    } else {
      this.setValue(value?.value, optionsData);
    }
  }

  setValue = (v, options) => {
    const { onChange, component: { trueValue, option1, option2, hasTypelist, useReviewLabel, label, reviewLabel } } = this.props || null;
    const typelist = hasTypelist ? { true: trueValue === 'option1' ? option1 : option2, false: trueValue !== 'option1' ? option1 : option2 } : null;
    const newLabel = useReviewLabel ? reviewLabel : label;
    const newV = (v === null || v === undefined) ? null : typelist ? { value: v, review: { label: newLabel, typelist } } : { value: v, review: { label: newLabel } };
    this.setState({ value: newV, options }, () => {
      // eslint-disable-next-line react/destructuring-assignment
      onChange(this.state.value);
    });
  };

  translateOptions = (options) => {
    const { intl } = this.props;
    return options.map((opt) => ({
      id: opt.id,
      value: opt.value,
      label: intl.formatMessage({ id: `${opt.label}`, defaultValue: `${opt.label}` }),
    }));
  };

  render() {
    const { state: { value, options }, props: { component: { hideCustomLabel, label, tooltip, tooltipTitle }, disabled, intl } } = this;

    return (
      options.length
        ? (
          <>
            {!hideCustomLabel && (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <label className="label-question">
                <FormattedMessage id={label} defaultMessage={label} />
              </label>
              {tooltip !== '' && (
              <Tooltip id="toggle_tooltip" primary title={intl.formatMessage({ id: tooltipTitle, defaultValue: tooltipTitle })}>
                <FormattedMessage id={tooltip} defaultMessage={tooltip} />
              </Tooltip>
              )}
            </div>
            )}
            <Switch
              disabled={disabled}
              value={value?.value !== null && value?.value !== undefined ? value.value : null}
              options={this.translateOptions(options)}
              name={`toggle_${Math.random() * 0xffffff}`}
              onChange={(v) => this.setValue(v, options)}
            />
          </>
        ) : null
    );
  }
};

const CustomToggleWithIntl = injectIntl(CustomToggle);

export default class ToggleComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'Custom Toggle',
      icon: 'check-square',
      group: 'basic',
      documentation: '',
      schema: ToggleComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customtoggle',
      },
      extend,
    );
  }

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */

  static editForm = CustomToggleSettingsForm;

  attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);

    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <CustomToggleWithIntl
          inputRef={(refer) => {
            instance = refer;
          }}
          disabled={this._disabled}
          component={this.component} // These are the component settings if you want to use them to render the component.
          value={this.dataValue || this.dataForSetting} // The starting value of the component.
          onChange={this.updateValue} // The onChange event to call when the value changes.
        />
      </IntlProvider>,
      element,
      // eslint-disable-next-line no-return-assign
      () => (this.reactInstance = instance),
    );
  }

  // eslint-disable-next-line class-methods-use-this
  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
